import { AFTER_CALL_CLOSED_EVENT, AfterCallCloseCause } from '../interpals/calls/after-call-event.js';
import { SURVEY_MOMENT_EVENT } from './survey-eligible.js';

/** The moment survey detail for one closed after-call screen, or null when no survey may open. */
export function callEndedMoment({ callId, cause, busy } = {}) {
    // A survey sheet over a ring or a new call traps focus away from its controls.
    if (cause !== AfterCallCloseCause.CLOSE || !callId || busy) return null;
    // The mobile call screen asks with the same event and context.
    return { event: 'call_ended', context: { call_id: String(callId) } };
}

/** Turns each closed after-call screen on the target into a moment survey event. */
export function registerCallSurveyTrigger(target) {
    target.addEventListener(AFTER_CALL_CLOSED_EVENT, (event) => {
        const detail = callEndedMoment(event.detail ?? {});
        if (detail) target.dispatchEvent(new CustomEvent(SURVEY_MOMENT_EVENT, { detail }));
    });
}

if (typeof window !== 'undefined') {
    registerCallSurveyTrigger(window);
}
